export const level = {
  LIMITED: '0',
  FULL: '1',
};
